import React from 'react';

const base = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};

export function GitHubIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.55 0-.27-.01-1.17-.02-2.12-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.03 1.76 2.69 1.25 3.35.96.1-.75.4-1.25.72-1.54-2.55-.29-5.24-1.28-5.24-5.68 0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.05 0 0 .96-.31 3.15 1.18a10.9 10.9 0 0 1 5.74 0c2.19-1.49 3.15-1.18 3.15-1.18.62 1.59.23 2.76.11 3.05.74.81 1.18 1.83 1.18 3.09 0 4.42-2.69 5.39-5.26 5.67.41.36.78 1.06.78 2.14 0 1.54-.02 2.79-.02 3.17 0 .31.21.67.8.55A11.51 11.51 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5Z" />
        </svg>
    );
}

export function LinkedInIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45Z" />
        </svg>
    );
}

export function MailIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...base} aria-hidden="true">
            <rect x="2.5" y="5" width="19" height="14" rx="2" />
            <path d="m3 6 9 7 9-7" />
        </svg>
    );
}

export function GlobeIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...base} aria-hidden="true">
            <circle cx="12" cy="12" r="9.5" />
            <path d="M2.5 12h19M12 2.5c2.7 2.6 4 6 4 9.5s-1.3 6.9-4 9.5c-2.7-2.6-4-6-4-9.5s1.3-6.9 4-9.5Z" />
        </svg>
    );
}

export function ArrowUpRight({ size = 14 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...base} strokeWidth={2} aria-hidden="true">
            <path d="M7 17 17 7M9 7h8v8" />
        </svg>
    );
}

export function ArrowDown({ size = 14 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...base} strokeWidth={2} aria-hidden="true">
            <path d="M12 4v16m0 0 6-6m-6 6-6-6" />
        </svg>
    );
}

export function LockIcon({ size = 14 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...base} aria-hidden="true">
            <rect x="4" y="10" width="16" height="10" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </svg>
    );
}

export function SunIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...base} aria-hidden="true">
            <circle cx="12" cy="12" r="4.5" />
            <path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.6 4.6l1.8 1.8M17.6 17.6l1.8 1.8M4.6 19.4l1.8-1.8M17.6 6.4l1.8-1.8" />
        </svg>
    );
}

export function MoonIcon({ size = 16 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...base} aria-hidden="true">
            <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11Z" />
        </svg>
    );
}

export const socialIconMap = {
    github: GitHubIcon,
    linkedin: LinkedInIcon,
    mail: MailIcon,
    globe: GlobeIcon,
};
